export const Name = 'accept-notification';
export const AcceptNotificationEvent = Name;
//# sourceMappingURL=index.js.map